// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3IQtd","label":"Completed_label__2NiF4"};